import { Button, Modal, ModalProps, Select } from 'antd';
import { usePlatformSelect } from '../ImplementData/components/Filter/Provider';
import { useState } from 'react';
import toLowerCase from 'utils/toLowerCase';
import { useTranslate } from '@tolgee/react';
import dayjs from 'dayjs';
import { DatePicker } from 'components/DatePicker';
import StatusButton from 'components/StatusButton';
import { exportHighRiskBuyer, exportMaliciousBuyer } from './service';
import styled from '@emotion/styled';
import { useExportFile } from 'components/ExportCenter/hooks/useExportCenter';

function ExportBuyerModal({
  type,
  ...otherProps
}: ModalProps & {
  type: 'highRisk' | 'malicious';
}) {
  const { t } = useTranslate();

  const [platform, setPlatform] = useState<General.PlatformUpperCase>();

  const [region, setRegion] = useState<General.UpperCaseRegion>();

  const [beginDate, setBeginDate] = useState(dayjs().subtract(7, 'days'));
  const [endDate, setEndDate] = useState(dayjs().subtract(1, 'days'));

  const {
    regionInfo: { regionList, regionsMap },
    platformSelect,
  } = usePlatformSelect({
    scene: 'ORDER_STAT',
    noDepartment: true,
    showPlatformAll: true,
    value: platform || 'ALL',
    onChange: (value) => {
      setPlatform(value === 'ALL' ? undefined : value);
      setRegion(undefined);
    },
  });

  const regions = platform ? regionsMap?.[toLowerCase(platform)] : regionList;

  const { runAsync } = useExportFile();

  return (
    <Modal
      width={800}
      title={t('导出买家明细')}
      footer={[
        <Button onClick={otherProps.onCancel}>{t('取消')}</Button>,
        <StatusButton
          type="primary"
          onClick={() => {
            return runAsync(() =>
              (type === 'highRisk' ? exportHighRiskBuyer : exportMaliciousBuyer)({
                externalType: platform,
                region,
                beginDate: beginDate.format('YYYY-MM-DD'),
                endDate: endDate.format('YYYY-MM-DD'),
              }),
            );
          }}
        >
          {t('导出')}
        </StatusButton>,
      ]}
      {...otherProps}
    >
      <Container>
        <div>
          {platformSelect}
          <Select
            dropdownMatchSelectWidth={false}
            placeholder={t('站点')}
            value={region || 'ALL'}
            onChange={(value: General.UpperCaseRegion | 'ALL') => {
              setRegion(value === 'ALL' ? undefined : value);
            }}
            options={[
              {
                value: 'ALL',
                label: t('全部站点'),
              },
              ...(regions || []).map((region) => {
                return {
                  value: region,
                  label: t(`region.${toLowerCase(region)}`),
                };
              }),
            ]}
          />
        </div>
        <div>
          <span>{t('outofstock_table_marktime')}</span>
          <DatePicker.RangePicker
            value={[beginDate, endDate]}
            onChange={(range) => {
              if (range) {
                const [start, end] = range;
                if (start && end) {
                  setBeginDate(start);
                  setEndDate(end);
                }
              }
            }}
          />
        </div>
      </Container>
    </Modal>
  );
}

const Container = styled.div`
  border: solid 1px #f0f2f5;
  > div {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    > * {
      margin-right: 16px;
    }
  }
  > div + div {
    border-top: solid 1px #f0f2f5;
  }
`;

export default ExportBuyerModal;
